import HiSocialLogo from "@/components/docs/HiSocialLogo";

const PAGE = {
  width: 794,
  minHeight: 1123,
  background: "#ffffff",
  color: "#18181b",
  position: "relative",
  overflow: "hidden",
  fontFamily: "'Helvetica Neue', Arial, sans-serif",
};

function GradientBar() {
  return (
    <div
      style={{
        width: 120,
        height: 6,
        borderRadius: 4,
        background: "linear-gradient(90deg,#ec0f8e,#a21caf)",
      }}
    />
  );
}

// Full preventivo document: cover page + detail sheet. Rendered at A4 px width for PDF export.
export default function PreventivoDoc({ data, logoUrl = null }) {
  const d = data || {};
  const items = Array.isArray(d.items) ? d.items : [];

  return (
    <div style={{ width: 794 }}>
      {/* ---------- COVER ---------- */}
      <div data-pdf-page style={{ ...PAGE, pageBreakAfter: "always", padding: "56px 64px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <HiSocialLogo size="lg" src={logoUrl} />
          <div style={{ fontSize: 13, letterSpacing: 2, color: "#3f3f46", fontWeight: 600, marginTop: 10 }}>
            MARKETING &amp; COMUNICAZIONE
          </div>
        </div>

        {/* decorative purple arc */}
        <div
          style={{
            position: "absolute",
            right: -260,
            top: 440,
            width: 620,
            height: 620,
            borderRadius: "50%",
            border: "2px solid #a21caf",
          }}
        />

        <div style={{ marginTop: 300 }}>
          <GradientBar />
          <h1 style={{ fontSize: 118, fontWeight: 800, margin: "18px 0 0", lineHeight: 1, letterSpacing: -3 }}>
            Preventivo<span style={{ color: "#ec0f8e" }}>.</span>
          </h1>
          <div style={{ fontSize: 30, color: "#3f3f46", marginTop: 14 }}>
            {d.cover_subtitle || "Strategia, creatività e comunicazione."}
          </div>
        </div>

        <div style={{ position: "absolute", left: 64, bottom: 150, right: 64 }}>
          <div style={{ fontSize: 13, letterSpacing: 2, color: "#a1a1aa", fontWeight: 600 }}>PREPARATO PER</div>
          <div style={{ fontSize: 28, fontWeight: 600, marginTop: 4 }}>{d.client_name || "Nome cliente"}</div>

          <div style={{ display: "flex", gap: 40, marginTop: 26, alignItems: "flex-end" }}>
            <div>
              <div style={{ fontSize: 12, letterSpacing: 2, color: "#a1a1aa", fontWeight: 600 }}>PROGETTO</div>
              <div style={{ fontSize: 22, fontWeight: 600, marginTop: 4 }}>{d.project || "Nome progetto"}</div>
            </div>
            <div style={{ width: 1, height: 44, background: "#d4d4d8" }} />
            <div>
              <div style={{ fontSize: 12, letterSpacing: 2, color: "#a1a1aa", fontWeight: 600 }}>DATA</div>
              <div style={{ fontSize: 22, fontWeight: 600, marginTop: 4 }}>{d.date_label || "GG.MM.AAAA"}</div>
            </div>
          </div>
        </div>

        <div
          style={{
            position: "absolute", left: 64, right: 64, bottom: 56,
            borderTop: "1px solid #e4e4e7", paddingTop: 16,
            display: "flex", justifyContent: "space-between",
            fontSize: 14, color: "#52525b",
          }}
        >
          <span>hi social italia</span>
          <span>hisocialitalia.it</span>
        </div>
      </div>

      {/* ---------- DETAIL SHEET ---------- */}
      <div data-pdf-page style={{ ...PAGE, padding: "48px 64px 80px" }}>
        <HiSocialLogo size="md" src={logoUrl} />
        <div style={{ marginTop: 26 }}><GradientBar /></div>
        <h1 style={{ fontSize: 72, fontWeight: 800, margin: "14px 0 0", lineHeight: 1, letterSpacing: -2 }}>
          Preventivo<span style={{ color: "#ec0f8e" }}>.</span>
        </h1>
        {d.project ? <div style={{ fontSize: 26, color: "#3f3f46", marginTop: 2 }}>{d.project}</div> : null}

        <div style={{ marginTop: 26 }}>
          <div style={{ fontSize: 24, fontWeight: 600 }}>{d.client_name || "—"}</div>
          {d.period ? <div style={{ fontSize: 18, color: "#a1a1aa", marginTop: 2 }}>{d.period}</div> : null}
        </div>

        <div style={{ borderTop: "1px solid #e4e4e7", margin: "28px 0 0" }} />

        {d.package_name ? (
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", padding: "24px 0" }}>
            <div style={{ fontSize: 30, fontWeight: 600 }}>{d.package_name}</div>
            <div style={{ fontSize: 30, fontWeight: 700 }}>
              {d.package_price}
              {d.package_unit ? <span style={{ fontSize: 16, color: "#a1a1aa", fontWeight: 400 }}> {d.package_unit}</span> : null}
            </div>
          </div>
        ) : null}

        <div style={{ borderTop: "1px solid #e4e4e7" }} />

        {items.map((it, i) => (
          <div key={i} style={{ display: "flex", gap: 20, padding: "22px 0", borderBottom: "1px solid #f4f4f5" }}>
            <div style={{ fontSize: 16, color: "#a1a1aa", fontWeight: 600, width: 28 }}>
              {String(i + 1).padStart(2, "0")}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 22, fontWeight: 600 }}>{it.title}</div>
              {it.description
                ? <div className="doc-rich" style={{ fontSize: 16, color: "#71717a", marginTop: 6, whiteSpace: "pre-wrap" }} dangerouslySetInnerHTML={{ __html: it.description }} />
                : null}
            </div>
            <div style={{ fontSize: 22, fontWeight: 700, whiteSpace: "nowrap" }}>
              {it.price}
              {it.unit ? <span style={{ fontSize: 15, color: "#a1a1aa", fontWeight: 400 }}> {it.unit}</span> : null}
            </div>
          </div>
        ))}

        {d.total_amount ? (
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", padding: "26px 0" }}>
            <div style={{ fontSize: 15, letterSpacing: 2, color: "#71717a", fontWeight: 600 }}>
              {(d.total_label || "TOTALE").toUpperCase()}
            </div>
            <div style={{ fontSize: 34, fontWeight: 700 }}>{d.total_amount}</div>
          </div>
        ) : null}

        {(d.payment_label || (d.tranches || []).length) ? (
          <div style={{ borderTop: "1px solid #e4e4e7", paddingTop: 22 }}>
            {d.payment_label ? (
              <div style={{ fontSize: 14, letterSpacing: 2, color: "#71717a", fontWeight: 600 }}>
                {d.payment_label.toUpperCase()}
              </div>
            ) : null}
            <div style={{ display: "flex", gap: 48, marginTop: 16 }}>
              {(d.tranches || []).map((t, i) => (
                <div key={i} style={{ flex: 1, borderLeft: i > 0 ? "1px solid #e4e4e7" : "none", paddingLeft: i > 0 ? 24 : 0 }}>
                  <div style={{ fontSize: 17, color: "#3f3f46" }}>{t.date}</div>
                  <div style={{ fontSize: 30, fontWeight: 700, marginTop: 2 }}>{t.amount}</div>
                  {t.label ? <div style={{ fontSize: 15, color: "#a1a1aa", marginTop: 2 }}>{t.label}</div> : null}
                </div>
              ))}
            </div>
            {d.note ? <div style={{ fontSize: 15, color: "#52525b", marginTop: 22 }}>{d.note}</div> : null}
          </div>
        ) : (d.note ? <div style={{ fontSize: 15, color: "#52525b", marginTop: 20 }}>{d.note}</div> : null)}

        <div style={{ position: "absolute", left: 64, right: 64, bottom: 40, fontSize: 14, color: "#71717a" }}>
          hisocialitalia.it
        </div>
      </div>
    </div>
  );
}
